import React, { forwardRef } from 'react'
import {
  ActionTileButton,
  ActionTileIconWrapper,
  ActionTileLabel
} from './ActionsSection.styles'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

const ReleaseActionTile = forwardRef(
  ({ icon, label, isActive = false, iconOffsetX = 0, ...props }, ref) => {
    const responsiveBreakpointsV2 =
      useReleaseInformationResponsiveBreakpointsV2()

    return (
      <ActionTileButton
        ref={ref}
        type="button"
        aria-label={label}
        title={undefined}
        $isActive={isActive}
        $responsiveBreakpointsV2={responsiveBreakpointsV2}
        {...props}
      >
        <ActionTileIconWrapper $offsetX={iconOffsetX}>
          {icon}
        </ActionTileIconWrapper>
        <ActionTileLabel $responsiveBreakpointsV2={responsiveBreakpointsV2}>
          {label}
        </ActionTileLabel>
      </ActionTileButton>
    )
  }
)

ReleaseActionTile.displayName = 'ReleaseActionTile'

export default ReleaseActionTile
